const getListdocumentKind = ($t) => {
  return [
    {
      code: '',
      label: '',
    },
    {
      code: 'id_card',
      label: `${$t('main.enums.documents.id_card')}`,
    },
    {
      code: 'proof_of_address',
      label: `${$t('main.enums.documents.proof_of_address')}`,
    },
    {
      code: 'bank_account_identity',
      label: `${$t('main.enums.documents.bank_account_identity')}`,
    },
    {
      code: 'tax_self_certification',
      label: `${$t('main.enums.documents.tax_self_certification')}`,
    },
    {
      code: 'proof_of_tax_address',
      label: `${$t('main.enums.documents.proof_of_tax_address')}`,
    },
    {
      code: 'guardianship_document',
      label: `${$t('main.enums.documents.guardianship_document')}`,
    },
  ]
}
export { getListdocumentKind }
